import React from "react";
import {
  CreditCard,
  Users,
  Sprout,
  Home,
  Briefcase,
  CheckCircle,
  RefreshCw,
} from "lucide-react";

export default function Auto() {
  return (
    <div className="bg-white w-full">
      {/* Top Header Bar (like image) */}
       <div className="w-full bg-white py-8 ">
    <h1 className="text-center text-4xl font-bold text-gray-900">
Auto Provitions
    </h1>
  </div>

      <div className="px-6 lg:px-20 py-12 -mt-10">
        {/* Overview Section (image style) */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            Overview
          </h2>

          <div className="bg-[#f1f7ff] rounded-2xl p-6 lg:p-8 relative">
            <div className="absolute left-0 top-6 bottom-6 w-1 bg-[#0b5ed7] rounded-full" />
            <p className="pl-6 text-gray-700 text-lg leading-relaxed">
              Auto Provisions is a technology-enabled credit facility that provides
              instant and hassle-free loans to eligible cooperative members. The
              system automatically assesses eligibility, determines credit limits,
              and enables quick disbursal for recurring and short-term financial
              needs—especially for farmers and rural households.
              <br /><br />
              This mechanism significantly reduces manual processing, ensures
              transparency, and supports members during key crop cycles and
              livelihood activities.
            </p>
          </div>
        </div>
{/* Full width grey section */}
<div className="-mx-6 lg:-mx-20 bg-gray-100 py-10 -mt-5">
  <h2 className="text-3xl font-semibold text-gray-900 mb-10 text-center">
    Who Can Avail
  </h2>

  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 px-6 lg:px-16">
    {[
      {
        title: "Know About Citizens Rights",
        bg: "bg-[#1e40af]",
      },
      {
        title: "Education & Public Library",
        bg: "bg-[#4338ca]",
      },
      {
        title: "Government Economy",
        bg: "bg-[#0f766e]",
      },
      {
        title: "Govt. International Current Affairs",
        bg: "bg-[#475569]",
      },
    ].map((card, index) => (
      <div
        key={index}
        className={`${card.bg} text-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-transform hover:-translate-y-1`}
      >
        <div className="flex justify-center mb-4">
          <div className="bg-white/20 rounded-full p-4">
            {/* icon here */}
          </div>
        </div>

        <h3 className="text-lg font-semibold text-center mb-2">
          {card.title}
        </h3>

        <p className="text-sm text-white/90 text-center leading-relaxed">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        </p>
      </div>
    ))}
  </div>
</div>


{/* Types */}
<div className="mb-16 -mx-6 lg:-mx-20 pt-2">
  <h2 className="text-3xl font-semibold text-gray-900 mb-10 text-center">
    Types
  </h2>

  <div className="flex flex-col md:flex-row items-stretch w-full">

    {/* Type 1 – Dark Blue */}
    <div className="relative flex-1 bg-[#264d6c] text-white px-8 py-6 shadow-md rounded-l-2xl">
      <div className="flex items-start gap-4">
        <div className="bg-white/20 p-2 rounded-full">
          <Sprout />
        </div>
        <div>
          <h3 className="text-xl font-semibold mb-2">
            Crop Cycle Auto Loans
          </h3>
          <ul className="list-disc list-inside text-sm space-y-1">
            <li>Immediate credit during sowing and input stages</li>
            <li>Repeatable for each cultivation season</li>
          </ul>
        </div>
      </div>

      <div className="hidden md:block absolute top-0 right-0 h-full w-10 bg-[#264d6c] chevron-right" />
    </div>

    {/* Type 2 – Mint Green */}
    <div className="relative flex-1 bg-[#cfece4] text-[#264d6c] px-8 py-6 shadow-md">
      <div className="flex items-start gap-4">
        <div className="bg-[#264d6c]/20 p-2 rounded-full">
          <Home />
        </div>
        <div>
          <h3 className="text-xl font-semibold mb-2">
            Short-Term Household Support Loans
          </h3>
          <p className="text-sm">
            For essential needs and micro activities
          </p>
        </div>
      </div>

      <div className="hidden md:block absolute top-0 right-0 h-full w-10 bg-[#cfece4] chevron-right" />
    </div>

    {/* Type 3 – Light Blue */}
    <div className="flex-1 bg-[#86aadf] text-white px-8 py-6 shadow-md rounded-r-2xl">
      <div className="flex items-start gap-4">
        <div className="bg-white/20 p-2 rounded-full">
          <Briefcase />
        </div>
        <div>
          <h3 className="text-xl font-semibold mb-2">
            Micro-Enterprise Auto Loans
          </h3>
          <p className="text-sm">
            For small traders, women entrepreneurs, and SHG-linked income
            activities
          </p>
        </div>
      </div>
    </div>

  </div>

  <style jsx>{`
    .chevron-right {
      clip-path: polygon(0 0, 85% 50%, 0 100%, 15% 100%, 100% 50%, 15% 0);
    }
  `}</style>
</div>

{/* How It Works */}
<div className="w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] bg-gray-100 py-16">
  <h2 className="text-3xl font-semibold text-gray-900 mb-12 text-center">
    How It Works
  </h2>

  <div className="max-w-7xl mx-auto px-6">
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {[
        {
          title: "Member Profile Sync",
          desc:
            "Membership details, land records, repayment history, and KCC status updated in MIS.",
          icon: <RefreshCw />,
        },
        {
          title: "Automated Credit Assessment",
          desc: "System calculates eligible credit limit.",
          icon: <CreditCard />,
        },
        {
          title: "Instant Approval",
          desc:
            "Eligible members receive automatic sanction without additional paperwork.",
          icon: <CheckCircle />,
        },
        {
          title: "Disbursal",
          desc:
            "Amount credited directly to the beneficiary’s account.",
          icon: <CreditCard />,
        },
        {
          title: "Tracking and Renewal",
          desc:
            "Members can view loan status and auto-renew cycles where applicable.",
          icon: <RefreshCw />,
        },
      ].map((step, index) => (
        <div
          key={index}
          className="bg-white rounded-2xl p-6 shadow-md border-t-4 border-[#0b5ed7]"
        >
          <div className="flex items-center gap-3 mb-3 text-[#0b5ed7]">
            {step.icon}
            <h4 className="text-lg font-semibold">
              {step.title}
            </h4>
          </div>
          <p className="text-gray-700 text-sm">
            {step.desc}
          </p>
        </div>
      ))}
    </div>
  </div>
</div>

      </div>
    </div>
  );
}
